/**
 * Created by Oles on 5/23/2017.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TableHeader extends Component {
    constructor(props) {
        super(props);
        this.handleMouseEv = this.handleMouseEv.bind(this);
        this.handleMouseUpEv = this.handleMouseUpEv.bind(this);
        this.state = {mouseDown: false, resizedColumnIndex: undefined, lastX: undefined};
        this.props.loadColumnsWidth();
    }

    componentDidMount() {
        // window.addEventListener('resize', this.props.onWindowResize(window.innerWidth - 15));
        window.onresize = e => {
            this.props.onWindowResize(window.innerWidth - 15);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.props.onWindowResize(window.innerWidth - 15));
    }

    handleMouseEv(e) {
        if (this.state.mouseDown) {
            var currentWidth = this.props.columns[this.state.resizedColumnIndex].width;
            var minWidth = this.props.columns[this.state.resizedColumnIndex].minWidth;
            var x = e.clientX;
            var delta = x - this.state.lastX;
            this.state.lastX = x;
            if (currentWidth + delta >= minWidth) this.props.onColumnResize(currentWidth + delta, this.state.resizedColumnIndex);
        }
    }

    handleMouseUpEv(e) {
        if (this.state.mouseDown) {
            var currentWidth = this.props.columns[this.state.resizedColumnIndex].width;
            var minWidth = this.props.columns[this.state.resizedColumnIndex].minWidth;
            var x = e.clientX;
            var delta = x - this.state.lastX;
            this.state.lastX = x;
            if (currentWidth + delta >= minWidth) this.props.onSaveColumnWidth(currentWidth + delta, this.state.resizedColumnIndex);
        }
        this.state.mouseDown = false;
        this.state.lastX = undefined;
        this.state.resizedColumnIndex = undefined;
    }

    render () {
        const headers = this.props.columns.map((column, index, columns) => {
            var first = index === 0;
            var last = index == columns.length - 1;
            let width = column.width + 'px';

            return <th key={column.title} style={{cursor: 'pointer', borderBottom: '1px solid #ddd', paddingRight: '0px', width: width, minWidth: column.minWidth + 'px', display: 'inline-block'}}>
                        <span type="text" style={{float: 'left', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 'calc(100% - 5px)'}}>
                            {column.title}
                        </span>
                        <span id={"test-results-table-column-resizer_" + index}
                              className="test-results-table-column-resizer fa fa-ellipsis-v"
                              style={{float: 'right', width: '5px', cursor: 'col-resize', visibility: first || last ? 'hidden' : 'visible', height: '15px', paddingTop: '2px'}}
                              onMouseDown={e => {this.state.mouseDown = true; this.state.lastX = e.clientX; this.state.resizedColumnIndex = index}}
                              onMouseUp={e => this.handleMouseUpEv(e)}
                        ></span>
                    </th>
        });

        return (
            <thead style={{backgroundColor: '#f9f9f9'}}>
                <tr onMouseMove={e => this.handleMouseEv(e)}
                    onMouseUp={e => this.handleMouseUpEv(e)}
                    style={{display: 'block'}}
                >
                    {headers}
                </tr>
            </thead>
        )
    }
}

TableHeader.PropTypes = {
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    onColumnResize: PropTypes.func.isRequired,
    onSaveColumnWidth: PropTypes.func,
    loadColumnsWidth: PropTypes.func
};